
import { TextShow } from 'Utils/Helpers/TextShow';
import { useSelector, useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { changeDoctors } from '../../../../../Redux/slices/staffSlice';
import { enqueueSnackbar } from 'notistack';
import Header from '../Header';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { editPosition } from 'http/components/UserService';

const title = 'پزشکان';

export default function SetDoctors() {
  const dispatch = useDispatch();
  const { total, maxd } = useSelector((state) => ({
    total: state.staff.total,
    maxd: state.setting.maxd,
  }));

  const handleChangeDoctors = async (event) => {
    const id = event.target.id;
    const index = +event.target.name;
    const checked = event.target.checked;
    if(!event.target.checked) {
      setData(id, checked, index);
    } else {
      if(total.filter(items => items.doctor).length < maxd) {
        setData(id, checked, index);
      } else {
        enqueueSnackbar('برای انتخاب بیش از یک پزشک حساب خود را به کلینیک ارتقا دهید', {variant: 'warning'});
      }
    }
  }

  const setData = async (id, checked, index) => {
    dispatch(HandleLoading(true));
    const response = await editPosition(id, checked);
    if(response.status) {
      if(response.data.status) {
        dispatch(changeDoctors({
          index, status: response.data.changeTo
        }))
      } else {
        dispatch(changeDoctors({
          index, status: false
        }))
      }
      dispatch(HandleLoading(false));
    } else {
      dispatch(HandleLoading(false));
    }
  }

  return (
    <>
      <Header title={title} justText />
      <div style={{padding: '0 10px'}}>
        <TextShow
          title={"انتخاب پزشکان مطب"}
          icon={<icons.PersonWorkspace size={18} />}
          justText
          className={'no-hide text-muted'}
        />
        <div className='group-checkbox'>
          {
            total && total.map((items, index) => {
              return (
                <div className='times-checkbox user-show'>
                  <FormControlLabel
                    key={`fcd-${index}`}
                    control={<Checkbox
                      name={index}
                      id={items.id}
                      sx={{margin: 0, padding: 0, marginLeft: '3px'}}
                      checked={items.doctor}
                      onChange={handleChangeDoctors}
                    />}
                    label={items.name}
                  />
                </div>
              )
            })
          }
        </div>
      </div>
    </>
  );
}